"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _alert = _interopRequireDefault(require("@amzn/meridian/alert"));
var _toaster = _interopRequireDefault(require("@amzn/meridian/toaster"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _FeedbackConstants = require("../constants/FeedbackConstants");
var _feedbackIntents = _interopRequireDefault(require("../enums/feedbackIntents"));
var _GeneralFeedback = _interopRequireDefault(require("./GeneralFeedback"));
var _TriggeredFeedback = _interopRequireDefault(require("./TriggeredFeedback"));
var _useResponse2 = _interopRequireDefault(require("../hooks/useResponse"));
var _createUserResponseObject = _interopRequireDefault(require("../utils/createUserResponseObject"));
var _useQuestions2 = _interopRequireDefault(require("../hooks/useQuestions"));
var _useNotification2 = _interopRequireDefault(require("../hooks/useNotification"));
var _isSiteExternal = require("../utils/isSiteExternal");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var FeedbackForm = function FeedbackForm(_ref) {
  var feedbackIntent = _ref.feedbackIntent,
    title = _ref.title,
    description = _ref.description,
    submitButtonSize = _ref.submitButtonSize,
    submitButtonType = _ref.submitButtonType,
    submitButtonText = _ref.submitButtonText,
    confirmationMessage = _ref.confirmationMessage,
    applicationId = _ref.applicationId,
    feedbackSubmissionPageIdentifier = _ref.feedbackSubmissionPageIdentifier,
    _ref$triggeredObj = _ref.triggeredObj,
    isTriggered = _ref$triggeredObj.isTriggered,
    resetTrigger = _ref$triggeredObj.resetTrigger,
    userId = _ref.userId,
    isSkippable = _ref.isSkippable,
    prePopulate = _ref.prePopulate,
    displayMode = _ref.displayMode;
  var isGeneralFeedback = feedbackIntent === _feedbackIntents["default"].General;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var _useState3 = (0, _react.useState)(0),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    startTime = _useState4[0],
    setStartTime = _useState4[1];
  var _useState5 = (0, _react.useState)(true),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    disabled = _useState6[0],
    setDisabled = _useState6[1];
  var _useResponse = (0, _useResponse2["default"])(),
    response = _useResponse.response,
    submitResponse = _useResponse.submitResponse,
    initializeResponse = _useResponse.initializeResponse;
  var _useQuestions = (0, _useQuestions2["default"])(),
    questions = _useQuestions.questions;
  var _useNotification = (0, _useNotification2["default"])(),
    toasts = _useNotification.toasts,
    onCloseToast = _useNotification.onCloseToast;

  // On first rendering set startTime to the current time if feedbackIntent is Triggered.
  (0, _react.useEffect)(function () {
    if (!isGeneralFeedback) {
      setStartTime(Date.now());
    }
  }, []);
  var requiredNotAnswered = function requiredNotAnswered(_ref2) {
    var isMandatory = _ref2.isMandatory,
      answer = _ref2.answer;
    return isMandatory && !(answer !== null && answer !== void 0 && answer.toString().trim());
  };
  (0, _react.useEffect)(function () {
    if (response.answers.some(requiredNotAnswered)) {
      setDisabled(true);
    } else {
      setDisabled(false);
    }
  }, [response]);
  var onClickLink = (0, _react.useCallback)(function () {
    setOpen(true);
    setStartTime(Date.now()); // set startTime to current time when user clicks on submit feedback link.
  }, []);
  var onClose = function onClose() {
    setOpen(false);
    resetTrigger();
    initializeResponse(questions); // reset questions
  };

  var sifProfileId = (0, _isSiteExternal.isSiteExternal)() ? _FeedbackConstants.SIF_PROFILE_ID : undefined;
  var onClickFooterButton = (0, _react.useCallback)(function () {
    var timeTakenToRespond = Date.now() - startTime; // total time taken to respond
    // user response object which will be stored in backend
    var _createUserResponseOb = (0, _createUserResponseObject["default"])(response, questions, timeTakenToRespond, feedbackSubmissionPageIdentifier, userId),
      userFeedback = _createUserResponseOb.userFeedback;
    submitResponse(applicationId, feedbackIntent, userFeedback, sifProfileId);
    onClose();
  });
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, feedbackIntent === _feedbackIntents["default"].General ? /*#__PURE__*/_react["default"].createElement(_GeneralFeedback["default"], {
    open: open,
    isDisabled: disabled,
    onClose: onClose,
    onClickLink: onClickLink,
    onClickFooterButton: onClickFooterButton,
    questions: questions,
    prePopulate: prePopulate,
    title: title,
    description: description,
    submitButtonSize: submitButtonSize,
    submitButtonType: submitButtonType,
    submitButtonText: submitButtonText,
    displayMode: displayMode
  }) : /*#__PURE__*/_react["default"].createElement(_TriggeredFeedback["default"], {
    open: isTriggered,
    isDisabled: disabled,
    onClose: onClose,
    onClickFooterButton: onClickFooterButton,
    questions: questions,
    prePopulate: prePopulate,
    title: title,
    description: description,
    submitButtonSize: submitButtonSize,
    submitButtonType: submitButtonType,
    submitButtonText: submitButtonText,
    isSkippable: isSkippable
  }), /*#__PURE__*/_react["default"].createElement(_toaster["default"], {
    toasts: toasts,
    onCloseToast: onCloseToast
  }, function () {
    return /*#__PURE__*/_react["default"].createElement(_alert["default"], {
      toast: true,
      type: "success"
    }, confirmationMessage);
  }));
};
FeedbackForm.propTypes = {
  feedbackIntent: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  description: _propTypes["default"].string,
  confirmationMessage: _propTypes["default"].string,
  submitButtonSize: _propTypes["default"].string,
  submitButtonType: _propTypes["default"].string,
  submitButtonText: _propTypes["default"].string,
  applicationId: _propTypes["default"].string.isRequired,
  feedbackSubmissionPageIdentifier: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func]),
  triggeredObj: _propTypes["default"].shape({
    isTriggered: _propTypes["default"].bool.isRequired,
    resetTrigger: _propTypes["default"].func.isRequired
  }).isRequired,
  userId: _propTypes["default"].string,
  isSkippable: _propTypes["default"].bool,
  prePopulate: _propTypes["default"].object.isRequired
};
FeedbackForm.defaultProps = {
  title: _FeedbackConstants.FEEDBACK_FORM_PROPERTIES.title,
  description: _FeedbackConstants.FEEDBACK_FORM_PROPERTIES.description,
  confirmationMessage: _FeedbackConstants.FEEDBACK_FORM_PROPERTIES.confirmationMessage,
  feedbackSubmissionPageIdentifier: null,
  submitButtonSize: _FeedbackConstants.SUBMIT_BUTTON_PROPERTIES.size,
  submitButtonType: _FeedbackConstants.SUBMIT_BUTTON_PROPERTIES.type,
  submitButtonText: _FeedbackConstants.SUBMIT_BUTTON_PROPERTIES.text,
  userId: null,
  isSkippable: true
};
var _default = exports["default"] = FeedbackForm;
//# sourceMappingURL=FeedbackForm.js.map